module.exports = __webpack_public_path__ + "static/background-hero-sm-e6d67038c2643d26c508e9d8029d07a0.png";